<div class="card ">
  <div class="card-header card-header-rose card-header-icon">
    <div class="card-icon">
      <i class="material-icons">work</i>
    </div>
    <h4 class="card-title">Ajouter une expérience</h4>
  </div>
  <div class="card-body ">
    <form [formGroup]="expForm" novalidate>
      <div class="col-md 12">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field [color]="param.color">
              <mat-label>De</mat-label>
              <input class="form-control" matInput [matDatepicker]="picker" formControlName="deb">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field [color]="param.color">
              <mat-label>A</mat-label>
              <input class="form-control" matInput [matDatepicker]="picker2" formControlName="fin">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field [color]="param.color" class="example-full-width">
              <input matInput placeholder="Intitulé du poste *" type="text" formControlName="intitule">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field [color]="param.color" class="example-full-width">
              <input matInput placeholder="Société *" type="text" formControlName="societe">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field [color]="param.color" appearance="legacy">
              <mat-label>Fonctions</mat-label>
              <mat-select panelClass="example-panel-{{param.color}}" formControlName="fonction" name="fonction">
                <mat-option *ngFor="let fonction of emploiFonction" [value]="fonction.fonction">{{fonction.fonction}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field [color]="param.color" appearance="legacy">
              <mat-label>Secteur</mat-label>
              <mat-select panelClass="example-panel-{{param.color}}" formControlName="secteur">
                <mat-option *ngFor="let secteur of secteurName" [value]="secteur.secteur_activite">{{secteur.secteur_activite}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field [color]="param.color" appearance="legacy">
              <mat-label>Niveau d'expertise</mat-label>
              <mat-select panelClass="example-panel-{{param.color}}"formControlName="expertise" id="experience">
                <mat-option *ngFor="let experiences of experienceName" [value]="experiences.experience">{{experiences.experience}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field [color]="param.color" appearance="outline">
              <mat-label>Description du poste</mat-label>
              <textarea type="text" rows="8" cols="40" matInput maxlength="255" formControlName="description" #description></textarea>
              <mat-hint aria-live="polite">
                {{description.value.length}} / 255
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-form-field [color]="param.color" appearance="outline">
              <mat-label>Compétence 1</mat-label>
              <textarea type="text" rows="2" cols="40" matInput maxlength="200" matInput formControlName="competence_1"></textarea>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field [color]="param.color" appearance="outline">
              <mat-label>Compétence 2</mat-label>
              <textarea type="text" rows="2" cols="40" matInput maxlength="200" matInput formControlName="competence_2"></textarea>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field [color]="param.color" appearance="outline">
              <mat-label>Compétence 3</mat-label>
              <textarea type="text" rows="2" cols="40" matInput maxlength="200" matInput formControlName="competence_3"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-footer ">
    <button _ngcontent-cfq-c3="" (click)="dialogRef.close(true)" class="btn btn-fill btn-rose">Annuler</button>
    <button mat-raised-button [disabled]="expForm.invalid" (click)="onSubmit()" type="submit" class="btn btn-fill btn-rose">Valider</button>
  </div>
</div>
